export enum EXEC_COMP_DATASET {
  exec = "exec",
  ai = "ai",
  board = "board",
}
